import React, { useState } from 'react'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import esLocale from 'date-fns/locale/es'
import DateFnsUtils from '@date-io/date-fns'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '96%',
    '@media (min-width: 480px)': {
      width: 'inherit'
    }
  }
}))

export default function DatePickerComponente (props) {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const { disableFuture, disablePast } = props

  const handleOnChange = (date) => {
    setSelectedDate(date)
    props.onDateChange(date)
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale} className={useStyles.root}>
      <DatePicker
        autoOk
        emptyLabel
        variant='inline'
        label='Seleccione una fecha'
        value={selectedDate}
        onChange={handleOnChange}

        // DisableFuture y DisablePast parametrizados para cuando sea necesario cambiar el default
        disableFuture={disableFuture || false}
        disablePast={disablePast || false}
        placeholder={``}
        format='yyyy/MM/dd'

      />
    </MuiPickersUtilsProvider>
  )
}
